import { useConfirmationScreen } from "./useConfirmationScreen";
import { Input } from "../../components/Input";
import Button from "../../components/Button";
import { Checkbox } from "../../components/Checkbox";
import { ClientTypeEnum } from "../../shared/enums";
import styles from "./styles.module.css";

export function ConfirmationScreen() {
  const hooks = useConfirmationScreen();

  return (
    <div className={styles.container}>
      <form onSubmit={hooks.handleSubmit} className={styles.confirmationForm}>
        <fieldset className="flex flex-column gap-4 align-items-center">
          <Input
            label="Número da unidade consumidora"
            value={hooks.unitNumber}
            disabled
          />
          {hooks.response.consultaUcResponse.tipoPessoa ===
            ClientTypeEnum.INDIVIDUAL && (
            <Input
              label="Primeiro nome da mãe"
              placeholder="Ex.: MARIA"
              onChange={hooks.handleFirstMotherNameChange}
              name="firstMotherName"
              value={hooks.firstMotherName}
            />
          )}
          <Input
            label="Número Predial"
            placeholder="Ex.: 12345"
            onChange={(e) => hooks.setBuildingNumber(e.target.value)}
            name="buildingNumber"
            disabled={hooks.isPredialNumberEmpty}
            value={hooks.buildingNumber}
          />

          <Checkbox
            inputId="predialNumberEmpty"
            value={false}
            onChange={hooks.handlePredialNumberEmptyChange}
            checked={hooks.isPredialNumberEmpty}
            label="Imóvel sem número predial"
          />
        </fieldset>
        <fieldset className="flex flex-column gap-6 align-items-center">
          <Button label="Confirmar" type="submit" className="mt-3" />
          <Button
            label="Cancelar"
            type="button"
            onClick={hooks.onBackToUcSearch}
            secondary
          />
        </fieldset>
      </form>
    </div>
  );
}
